import React from 'react'

import { ANGLE_MAP } from '@ui/icons/utils/icon-direction'
import { withDirectionalStatics } from '@ui/icons/utils/withDirectionalStatics'

export const DownloadIcon = withDirectionalStatics((props) => {
  const { size, color, direction = 'up' } = props
  const rotation = ANGLE_MAP[direction] ?? 0

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <g transform={`rotate(${rotation} 12 12)`}>
        <path
          d='M18 20C18.5523 20 19 20.4477 19 21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21C5 20.4477 5.44772 20 6 20H18ZM12 2C12.5523 2 13 2.44772 13 3V14.5859L16.293 11.293C16.6835 10.9024 17.3165 10.9024 17.707 11.293C18.0976 11.6835 18.0976 12.3165 17.707 12.707L12.707 17.707C12.3165 18.0976 11.6835 18.0976 11.293 17.707L6.29297 12.707C5.90244 12.3165 5.90244 11.6835 6.29297 11.293C6.68349 10.9024 7.31651 10.9024 7.70703 11.293L11 14.5859V3C11 2.44772 11.4477 2 12 2Z'
          fill={color}
        />
      </g>
    </svg>
  )
})
